// избранные фильтры для категорий

import { ID_ACTUAL_ATTRIBUTE, ID_SUBCATEGORY_ATTRIBUTE, ID_TYPE_PRODUCT_ATTRIBUTE } from '@shared/constants/keys';

export const IMPORTANT_FILTERS: Record<string, string[]> = {
  tumby: [
    '66d6c80acbfb7d6b8bea4b6f', // цена
    '6644749b5c22ed91d02cce0c', // ширина
    '6644977c5c22ed91d02cd14f', // цвет
    '6644949b5c22ed91d02cd002' // материал фасада
  ],
  shkafy: [
    '66d6c80acbfb7d6b8bea4b6f', // цена
    '6644749b5c22ed91d02cce0c', // ширина
    '6644977c5c22ed91d02cd14f', // цвет
    '6644949b5c22ed91d02cd002' // материал фасада
  ],
  zerkala: [
    '66d6c80acbfb7d6b8bea4b6f', // цена
    '6644749b5c22ed91d02cce0c' // ширина
  ]
};

// заголовки для фильтров
export const FILTER_LABELS: Record<string, string> = {
  '66d6c80acbfb7d6b8bea4b6f': 'Цена'
};

// исключения для фильтров что бы счетчик с активными фильтрами правильно считался
export const EXCLUDED_FILTERS = [
  ID_TYPE_PRODUCT_ATTRIBUTE,
  ID_SUBCATEGORY_ATTRIBUTE,
  ID_ACTUAL_ATTRIBUTE,
  '66f27137cbfb7d6b8bea4bc8'
];
